import Header from '../Navigation/Header'
import Footer from '../Navigation/Footer'
import { ClientsBanner } from '../../components/ClientsBanner'
import { Seo } from '../../helpers/Seo'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react'

export default function LoanNoJob() {
    return (
        <div>
            <Seo
                title="Prêt sans emploi | Trouvez les meilleures offres | Argent Aujourd’hui"
                description="Découvrez des solutions de prêt même sans emploi sur notre site. Comparez les offres et trouvez celle qui vous convient le mieux en toute simplicité."
                type="webapp"
                name="Argent Aujourd'hui"
            />
            <Header />

            <section className="header">
                <div data-aos="fade-up">
                    <h1 className="header-title">Prêt sans emploi</h1>

                    <p className="header-subtitle">
                        Emprunter sans avoir de revenu d’emploi, c’est possible grâce au financement
                        alternatif! Obtenez des prêts sans emploi de 100 à 1500 $ sans enquête de
                        crédit grâce à Argent Aujourd’hui, votre comparateur québécois pour obtenir
                        des prêts rapides à taux avantageux.
                    </p>

                    <Link to="/new-lead" className="btn">
                        Demander un prêt
                    </Link>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">
                        Comment puis-je obtenir un prêt si je ne travaille pas?
                    </h2>

                    <p className="sect-subtitle">
                        Quelle que soit votre situation, un prêt urgent peut offrir une solution
                        rapide en cas d’imprévu. Vous vous demandez s’il est aussi possible
                        d’emprunter sans revenus d’emploi? Certaines institutions proposent des
                        solutions alternatives, même si vous n’êtes pas salarié. Pour trouver les
                        meilleurs prêts d’argent rapide sans emploi, Argent Aujourd’hui vous offre
                        une comparaison des solutions de financement sans vérification de crédit au
                        Québec.
                    </p>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Une démarche simple et rapide</h2>

                    <p className="sect-subtitle">
                        Obtenez une comparaison de solution de prêts personnels sans emploi en
                        quelques clics avec Argent Aujourd’hui! En plus d’être simple et rapide, la
                        démarche est entièrement gratuite et sans engagement! Voici les étapes à
                        suivre :
                    </p>

                    <div className="steps" style={{ marginTop: 50 }}>
                        <ol>
                            <li>
                                <h3>
                                    Remplir notre{' '}
                                    <Link to="/new-lead">formulaire de demande en ligne</Link>
                                </h3>
                                <p>
                                    Commencez par nous renseigner vos informations personnelles et
                                    vos besoins en matière de prêt sans emploi.
                                </p>
                            </li>
                            <li>
                                <h3>Comparer les offres</h3>
                                <p>
                                    Sur base de vos renseignements, nous vous proposons des
                                    solutions de financement en ligne qui proposent des prêts
                                    rapides si vous êtes au chômage ou sans emploi. Comparez les
                                    institutions selon le montant qu’ils peuvent vous offrir, leur
                                    délai de versement et leur prix.
                                </p>
                            </li>
                            <li>
                                <h3>Faire votre demande de prêt</h3>
                                <p>
                                    Une fois que vous avez choisi l’institution qui répond le mieux
                                    à vos besoins, il vous suffit de cliquer sur le lien du prêteur
                                    et vous serez automatiquement dirigé vers leur site. Vous devrez
                                    leur fournir des renseignements supplémentaires sur votre
                                    situation pour effectuer la demande.
                                </p>
                            </li>
                            <li>
                                <h3>Obtenez votre prêt en 24h</h3>
                                <p>
                                    Si votre demande est approuvée, vous devriez recevoir votre prêt
                                    par virement interac dans les 24 heures suivant la signature de
                                    votre contrat. Tenez compte des heures d’ouverture de
                                    l’institution pour évaluer le moment où votre demande sera
                                    traitée.
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">
                        Puis-je réellement obtenir un prêt si je ne travaille pas?
                    </h2>

                    <p className="sect-subtitle">
                        Nous comprenons que dans certaines situations, un prêt urgent sans emploi
                        peut être nécessaire. Vous cherchez un prêt même avec un mauvais crédit et
                        sans emploi? Quand votre contexte ne répond pas aux critères des
                        institutions financières classiques, d’autres solutions existent. Au Québec,
                        des prêteurs alternatifs proposent des avances de fond,{' '}
                        <b>sans avoir à fournir de justificatif d'emploi.</b>
                    </p>

                    <p className="sect-subtitle">
                        Même s’il n’y a pas de preuve de salaire exigée, vous devez répondre aux
                        critères suivants pour être admissible à un prêt instantané sans emploi :
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 20 }}>
                        <li>Avoir 18 ans et plus</li>
                        <li>Résider au Québec</li>
                        <li>
                            Avoir un revenu stable (par exemple, des prestations gouvernementales ou
                            un travail à la pige)
                        </li>
                        <li>Ne pas avoir d’opposition de paiement</li>
                        <li>
                            Avoir le moins de frais de fonds non suffisants possible (frais NSF)
                        </li>
                    </ul>

                    <p className="sect-subtitle">
                        Si vous répondez à toutes ces conditions, vous pourriez être éligible à un
                        mini prêt sans emploi dès aujourd’hui!
                    </p>

                    <Link to="/new-lead" className="btn">
                        Demander un prêt
                    </Link>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Choisissez le montant dont vous avez besoin!</h2>

                    <p className="sect-subtitle">
                        Selon vos besoins, nos partenaires proposent des prêts sans emploi de
                        différents montants :
                    </p>

                    <div className="loan-options">
                        <ul>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 100$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 200$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 300$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 500$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 700$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 000$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 500$</li>
                            </Link>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Les avantages de nos produits</h2>

                    <p className="sect-subtitle">
                        En plus de vous trouver des prêts d’argent urgents sans emploi au meilleur
                        taux du marché, Argent Aujourd’hui c’est aussi :
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 30 }}>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Une approbation rapide</h4>

                            <span style={{ marginTop: 130 }}>
                                Obtenez le montant requis dans un délai de 24h après l'approbation
                                de votre demande.
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Des prêts IBV</h4>

                            <span style={{ marginTop: 130 }}>
                                Plutôt que de vérifier votre cote de crédit, nos partenaires
                                effectuent des vérifications bancaires instantanées (IBV) pour
                                évaluer votre capacité de remboursement.
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Un processus sécuritaire</h4>

                            <span style={{ marginTop: 130 }}>
                                Démarche fiable, gratuite et sans engagement, avec des institutions
                                québécoises vérifiées.
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Une solution même en cas de mauvais crédit</h4>

                            <span style={{ marginTop: 130 }}>
                                Nous ne regardons pas votre historique, mais votre situation
                                actuelle!
                            </span>
                        </li>
                    </ul>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Nos prêts répondent à différents besoins</h2>

                    <p className="sect-subtitle">
                        Découvrez nos autres solutions de financements alternatifs pour répondre à
                        vos besoins d’argent immédiats :
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 20 }}>
                        <li>Avance de fonds</li>
                        <li>Prêt d'urgence</li>
                        <li>Prêt personnel</li>
                        <li>Prêt sur salaire</li>
                    </ul>

                    <Link to="/new-lead" className="btn" style={{ marginTop: 30 }}>
                        Demander un prêt
                    </Link>
                </div>
            </section>

            <ClientsBanner />

            <Footer />
        </div>
    )
}
